'use client';

import {useEffect} from 'react';
import globalNavigation from '@/utils/global-navigation';

import useMyStore from '@/stores/my';
import {useNavigate} from 'react-router-dom';
import useMainStore from '@/stores/main';
import useGlobalUIStore from '@/stores';

import {throttle} from 'lodash';
import {sendWebUvLog} from '@/utils/main';

/**
 * 숲 내비게이션 로더 컴포넌트
 *
 * 숲 내비게이션 초기화 및
 * 스토어에 들어있는 유저 정보 / 광고 / 테마 셋팅을 한다
 */
const NavigationLoader = () => {
  const {setMyInfo} = useMyStore();
  const {setCheckAd} = useMainStore();
  const {setIsDarkMode, setRefreshTimestamp, setIsLnbOpened} =
    useGlobalUIStore();

  const navigate = useNavigate();

  const throttleNavigate = throttle(
    (path) => {
      // useLocation의 location.pathname() 이건 싱크가 좀 안맞는다. (왜그런진 모름)
      // soop-navigation으로 부터 동일한 path로 라우팅 요청이 왔을땐 refreshTimestamp를 발동
      // queryString이 있는 경우엔 navigation으로 이동 시켜 querySTring을 초기화 시킨다. 예) MY 서브 그룹/favorite?groupId=2186 같은 경우 /favorite로 이동
      if (path === '/' && path === window.location.pathname) {
        // / (로고클릭) 시 어차피 새로 고침이기 떄문에 굳이 setRefreshTimestamp 할 필요 없다
        return;
      }
      if (path === window.location.pathname && !window.location.search) {
        setRefreshTimestamp();
        sendWebUvLog();
      } else {
        navigate(path);
      }
    },
    500,
    {leading: true, trailing: false},
  );

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !globalNavigation?.getNavigationInstance()
    ) {
      const gnb = document.getElementById('soop-gnb');
      const snb = document.getElementById('soop-snb');
      const fnb = document.getElementById('soop-fnb');

      // 숲 내비게이션 등록
      globalNavigation.init(gnb, snb, fnb);

      // 숲 내비게이션으로부터 유저 정보 받아오기
      globalNavigation.handleAuthorized((user) => {
        setMyInfo(user);
      });

      // SoopNavigation으로 부터 콜백을 받아서 이곳에서 실행해야 하는 불상사
      // Next Router <-> Other Js lib 간 연동할 방법이 없음
      globalNavigation.handleInternalRouteChange((path) => {
        throttleNavigate(path);
        //navigate(path);
      });

      // 광고 정보 셋팅하기
      globalNavigation.handleNewAdChecked(
        ({hasNewAd, banners, AdParameter}) => {
          setCheckAd({
            hasNewAd: hasNewAd,
            banners: banners,
            AdParameter: AdParameter,
          });
        },
      );

      // 테마 정보 셋팅하기
      globalNavigation.handleThemeChanged((themeInfo) => {
        // navigation에서 전달해주는 테마값을 이곳에서 store에 set
        // 다크모드, lnb 펼침 상태 등
        if (themeInfo.type === 'size') {
          setIsLnbOpened(themeInfo.value !== 'mini');
        } else {
          setIsDarkMode(themeInfo.value === 'dark');
        }
      });
    }
  }, []);

  return <></>;
};

export default NavigationLoader;
